import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Portrait } from "@/components/Portrait";
import { Record } from "@/components/Record";
import { County } from "@/components/Constituency";
import { PartySection } from "@/components/PartySection";
import { Vision } from "@/components/Vision";
import { SupportForm } from "@/components/SupportForm";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#0B0C10] text-stone-100 overflow-x-clip">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Portrait />
        <Record />
        <County />
        <PartySection />
        <Vision />
        <SupportForm />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" richColors />
    </div>
  );
}

export default App;
